import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidReadingMatrixStopwatch } from '../../../../mechanics/rid-reading-matrix-stopwatch/rid-reading-matrix-stopwatch';

@Component({
  selector: 'app-reading-matrix-stopwatch-page',
  imports: [RidReadingMatrixStopwatch],
  templateUrl: './reading-matrix-stopwatch-page.html',
})
export class ReadingMatrixStopwatchPage {
  protected readonly $activatedRoute = inject(ActivatedRoute);
  protected readonly $router = inject(Router);

  protected readonly previousDuration = () => parseInt(this.$activatedRoute.snapshot.queryParams['previous-duration'] ?? '30');
}
